export class ContractService {
  public static getContracts = () => {};
  public static getContractsById = () => {};
  public static saveContract = () => {};
  public static updateContract = () => {};
  public static deleteContract = () => {};
}
